export default {
  tags: 'Tags',
  time_zone: 'Time Zone'
}
